import { useNavigate } from "react-router";
import { PageHeader, PageShell, Spinner } from "@bruntworkwear-apps/ui";
import { useRun } from "@/app/providers";
import { reauthenticate, SessionExpiredError } from "@/shared/api";
import { useAppConfig } from "@/modules/overview";
import { useReconcile } from "./api";
import { UploadForm, type UploadFormValues } from "./components/UploadForm";

/**
 * Step one: upload both workbooks and run.
 *
 * On success the result goes into the run context and the user lands on the
 * review, because a completed run with nothing shown is indistinguishable from
 * one that failed.
 */
export function UploadModule() {
  const navigate = useNavigate();
  const { setResult } = useRun();
  const config = useAppConfig();
  const reconcile = useReconcile();

  const start = (values: UploadFormValues) => {
    reconcile.mutate(values, {
      onSuccess: (result) => {
        setResult(result);
        void navigate("/review");
      },
    });
  };

  return (
    <PageShell>
      <PageHeader
        title="Run a reconciliation"
        description="Upload the NetSuite item receipt export and the Ops master tracker."
      />
      {config.data ? (
        <UploadForm
          defaults={config.data.defaults}
          receiptSource={config.data.receipt_source}
          isRunning={reconcile.isPending}
          error={reconcile.error?.message ?? null}
          isSessionExpired={reconcile.error instanceof SessionExpiredError}
          onSubmit={start}
          onReauthenticate={reauthenticate}
        />
      ) : (
        <Spinner label="Loading settings" />
      )}
    </PageShell>
  );
}
